import { Link } from "react-router-dom";
import './InfoLayout.css'; // import CSS

function InfoLayout({ title, children }) {
    return (
        <div className="layout-container">
            {/* Levý sloupec - menu */}
            <aside className="sidebar">
                {/* Logo nahoře */}
                <div className="sidebar-logo">
                    <img src="/images/tabataworkout_logo_white.png" alt="Logo" />
                </div>

                <h2 className="sidebar-title">Tabata časovač</h2>
                <nav>
                    <ul className="menu-list">
                        
                        <li><Link to="/about" className="menu-link">O aplikaci</Link></li>
                        <li><Link to="/contact" className="menu-link">Kontakt/Support</Link></li>
                        <li><Link to="/version" className="menu-link">Verze</Link></li>
                        <li><Link to="/compatibility" className="menu-link">Kompatibilita</Link></li>
                        <li><Link to="/offer" className="menu-link">Reklamní prostor</Link></li>
                        <li><Link to="/disclaimer" className="menu-link">Disclaimer</Link></li>
                        <li><Link to="/license" className="menu-link">Licenční podmínky</Link></li>
                        <li><Link to="/privacy-policy" className="menu-link">Ochrana údajů</Link></li>
                        
                        
                        <li><Link to="/" className="menu-link">Úvodní stránka</Link></li>
                    </ul>
                </nav>
            </aside>

            {/* Pravý obsah */}
            <main className="content">
                <h1 className="content-title">{title}</h1>
                <div className="content-box">{children}</div>
            </main>
        </div>
    );
}

export default InfoLayout;
